import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Days } from '@time-off-v3/meta/time-off-meta';
import { WeekdayDisplayOptions } from '@app/types/translatables/time-off-v3-display.options';

@Component({
    selector: 'app-day-selector',
    templateUrl: './day-selector.html',
    styleUrls: ['./day-selector.style.scss'],
})
export class DaySelectorComponent {
    @Input() days: string[] = Days;
    @Input() selected: string[];
    @Output() selectedChange: EventEmitter<string[]> = new EventEmitter<string[]>();

    weekdayDisplayOptions = WeekdayDisplayOptions;

    onClick(day: string): void {
        this.selected = this.selected.includes(day)
            ? this.selected.filter((selectedDay) => selectedDay !== day)
            : [...this.selected, day];

        this.selectedChange.emit(this.selected);
    }
}
